import defaultLogo from "@assets/Tabla.svg";
import LinkIcon from "@elements/Icon/LinkIcon";
import { Link } from "react-router";
import { twMerge } from "tailwind-merge";

export type authorProps = {
  destination: string;
  authorSrc: string;
  iconClassName?: string;
  authorName: string;
};

export default function Author({
  destination,
  authorSrc,
  iconClassName,
  authorName,
}: authorProps) {
  const sizedSrc =
    authorSrc && !authorSrc.includes("?") ? `${authorSrc}?w=240` : authorSrc;

  return (
    <>
      {destination && (
        <div className="inline-flex text-grey-200 font-primary font-bold xmd:mb-3 mr-3 pb-3 px-3 md:px-4 lg:px-0">
          <LinkIcon
            destination={destination}
            src={sizedSrc || defaultLogo}
            alt="author"
            height="60px"
            width="60px"
            className={twMerge("p-1 mr-3 rounded-[60px]", iconClassName)}
            onClick={() => {
              window.location.reload();
            }}
            target="_self"
          />
          <Link
            reloadDocument
            to={destination}
            className="text-grey-200 text-lg underline place-content-center"
          >
            {authorName}
          </Link>
        </div>
      )}
    </>
  );
}
